<template>
  <div v-if="mainConfig.enableSorting" class="ta-sorting-dropdown">
    <label>{{ $t('Sort By') }} </label>
    <b-form-select
      :options="sortOptions"
      v-model="sort"
      @change="updateSorting"
    ></b-form-select>
  </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import lotListFilterMixin from "../../../mixins/lotListFilterMixin";
import {lotSortingChange} from "@/triggers";

export default {
  name: "SortingDropdown",
  mixins: [lotListFilterMixin],
  data: () => ({
    sort: 'end_date=desc',
  }),
  computed: {
    ...mapState(['mainConfig']),
    ...mapGetters(['dynamicFields']),
    defaultSortOptions() {
      const options = [
        { text: this.$t('Live Auctions First'), value: 'active_auctions_first=asc' },
        { text: this.$t('Finished Auctions First'), value: 'active_auctions_first=desc' },
        { text: this.$t('Most Visited/Viewed'), value: 'visited=desc'},
        { text: this.$t('Newest (Published)'), value: 'publish_date=desc'},
        { text: this.$t('Lowest Price'), value: 'price=asc'},
        { text: this.$t('Highest Price'), value: 'price=desc'},
        { text: this.$t('Highest Number of Bids'), value: 'bid_count=desc'},
        { text: this.$t('Least time Left'), value: 'end_date=asc'},
        { text: this.$t('Lowest Lot Number'), value: 'lot_no=asc'},
        { text: this.$t('Highest Lot Number'), value: 'lot_no=desc'},
        ...this.dynamicFields.filter(f => f.sortable).map(f => ({
          text: this.$t(`sort_dynamic_field.${f.label} ASC`),
          value: `dynamic_fields-${f.key}=asc`
        })),
        ...this.dynamicFields.filter(f => f.sortable).map(f => ({
          text: this.$t(`sort_dynamic_field.${f.label} DESC`),
          value: `dynamic_fields-${f.key}=desc`
        }))
      ];
      return options.sort((a, b) => a.text < b.text ? -1 : 1);
    },
    /** From mainConfig.lotSortOptions (array of { text, key, direction } or { text, preferences }). */
    sortOptions() {
      const opts = this.mainConfig.lotSortOptions;
      if (Array.isArray(opts) && opts.length > 0) {
        return opts.map(o => ({
          text: o.text,
          value: o.preferences ? JSON.stringify(o.preferences) : `${o.value}`
        }));
      }
      return this.defaultSortOptions;
    }
  },
  methods: {
    updateSorting() {
      let label = this.sort;
      const hasPreferences = this.sort.trim().startsWith('[');
      if (hasPreferences) {
        try {
          const sortPreferences = JSON.parse(this.sort);
          if (Array.isArray(sortPreferences) && sortPreferences.length > 0) {
            this.fields.setFilters({sort_preferences: this.sort, sort: null, 'sort-by': null});
            label = sortPreferences.map(p => `${p.key} ${p.direction}`).join(', ');
          }
        } catch (e) {
          console.log(e)
        }
      } else {
        const [key, direction] = this.sort.split('=');
        if (key && direction) {
          this.fields.setFilters({sort: key, 'sort-by': direction, sort_preferences: null});
          label = `${key} ${direction}`;
        }
      }
      this.fields.updateRoute();
      lotSortingChange(label);
    },
  },

  mounted() {
    const q = this.fields.queryParams;
    const opts = this.mainConfig.lotSortOptions;
    const isCustom = Array.isArray(opts) && opts.length > 0;
    if (q.sort_preferences && Array.isArray(q.sort_preferences) && q.sort_preferences.length > 0) {
      const prefs = q.sort_preferences;
      this.sort = prefs.length === 1 && prefs[0].key != null
        ? `${prefs[0].key}=${prefs[0].direction}`
        : (isCustom ? JSON.stringify(prefs) : `${prefs[0].key}=${prefs[0].direction}`);
    } else if (q.sort && q['sort-by']) {
      this.sort = `${q.sort}=${q['sort-by']}`;
    } else if (isCustom) {
      this.sort = opts[0].preferences ? JSON.stringify(opts[0].preferences) : `${opts[0].key}=${opts[0].direction}`;
    }
  }
}
</script>

<style lang="scss" scoped>
#artisioTimedAuctions {
  .ta-sorting-dropdown {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;

    label {
      margin-right: 0.5rem;
      margin-bottom: 0;
      white-space: nowrap;
    }
  }
}
</style>
